import { render, staticRenderFns } from "./BorrowReturn.vue?vue&type=template&id=f80098d4&scoped=true&"
import script from "./BorrowReturn.vue?vue&type=script&lang=js&"
export * from "./BorrowReturn.vue?vue&type=script&lang=js&"
import style0 from "./BorrowReturn.vue?vue&type=style&index=0&id=f80098d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80098d4",
  null
  
)

export default component.exports